import { render, staticRenderFns } from "./ButtonWithConfirmation.vue?vue&type=template&id=a36bde72&scoped=true&"
import script from "./ButtonWithConfirmation.vue?vue&type=script&lang=js&"
export * from "./ButtonWithConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36bde72",
  null
  
)

export default component.exports